import { withStyles } from "@material-ui/core/styles";
import React from "react";
import Component from "src/components/Component";
import Page from "src/components/Page";
import withAppContext from "src/components/withAppContext";
import withAxios from "src/components/withAxios";
import { withSchoolContext } from "../../DirectorPage";
import { styles } from "./styles";
import { IDirectorSettingsState, IProps } from "./types";
import LoadingSpinner from "src/components/LoadingSpinner";
// import { ZENDESK_PARENT_SERVEY, ZENDESK_UPGRADE_PLAN } from "src/constants";
export default withAppContext(
  withSchoolContext(
    withStyles(styles)(
      withAxios(
        class extends Component<IProps, IDirectorSettingsState> {
          public readonly state = this.buildState({
            loader: false,
            getAllPlanData: [],
            getAllAddonData: [],
            subscriptionPlan: {},
            activeContainer: [],
            upgradeDetails: {},
            planData: []

          });
          public async componentDidMount() {
            const planres: any = await this.buildGet(this, "payment/getPlanHistory/" + this.props.school.id)()
            this.setState({ planData: planres?.data[0] })
            this.getUpgradeDetails()

          }

          public getAlreadyAvailableAddonTotal = () => {
  const { getAllAddonData } = this.state;

  return getAllAddonData
    .filter((item: any) => item?.is_available === true)
    .reduce((total: number, item: any) => {
      return total + Number(item?.price || 0);
    }, 0);
};

          public getUpgradeDetails = () => {
            const searchParams = new URLSearchParams(window.location.search);
            const membershipId = searchParams.get("membership_id");
            
            const storedObject: string = localStorage.getItem("upgradeDetails") || '{}';  // Fallback to an empty object string
            const parsedObject = JSON?.parse(storedObject);
            
            if (Object.keys(parsedObject).length > 0) {
              // Add membership_id to upgradeDetails only if membershipId is not null
              const updatedUpgradeDetails = membershipId 
                ? { ...parsedObject, membership_id: membershipId }
                : parsedObject;
              
              // Save back to localStorage
              localStorage.setItem("upgradeDetails", JSON.stringify(updatedUpgradeDetails));
              
              this.setState({ upgradeDetails: updatedUpgradeDetails }, () => {
                this.setState({ subscriptionPlan: this.state?.upgradeDetails?.plan })

                console.log("Current subscriptionPlan ",this.state.upgradeDetails)

                this.getAllAddonHandler()
              })
            }
          }
          public planIDgets() {
            switch (this.state.subscriptionPlan.id) {
              case 2:
                return [1, 2, 3, 4]
              case 3:
                return [2, 3, 4]
              case 4:
                return [3, 4]
              case 5:
                return [4]
              default:
                return []
            }
          }
          public async getAllAddonHandler() {
            this.setState({ loader: true })
            const url = `/payment/getAddonPlan/${this.state.planData?.membership?.id}?type=school`;
            const res: any = await this.buildGet(this, url)()
            if (res.status && res?.data?.length > 0) {
              console.log("res.data=======>", res.data)
              // const data = res.data.find((itm:any)=>this.state.subscriptionPlan.id===itm.id)
              // console.log("data=========>",data)
              const planAddon: any = []
              if (res?.data?.length > 0) {
                res.data.map((item: any) => {
                  if (this.planIDgets().includes(item.id)) {
                    planAddon.push(item)
                  }
                })
              }
              const data = planAddon.sort((a: any, b: any) => a.id - b.id);

              this.setState({ getAllAddonData: data })
              console.log("getAllAddonData", this.state.getAllAddonData)
              this.setState({ loader: false })
            } else {
              this.setState({ loader: false })
            }
            // this.setState({ user: res })
          }

          public toggleContainer(id: number) {
            // this.setState({ activeContainer: containerId === this.state.activeContainer ? null : containerId });
            this.setState((prevState: any) => {
              const { activeContainer } = prevState;

              if (activeContainer.length > 0 && activeContainer.includes(id)) {
                // If the id is already in the array, remove it
                return { activeContainer: activeContainer.filter((itemId: any) => itemId !== id) };
              } else {
                // If the id is not in the array, add it
                return { activeContainer: [...activeContainer, id] };
              }
            });
          }

         public NextHandler() {
   const tempData: any = []
  if (this.state.activeContainer?.length > 0) {
    this.state.getAllAddonData.map((item: any) => {
      if (this.state.activeContainer.includes(item.id)) {
        tempData.push(item)
      }
    })
  }

  // ✅ already available addons total price
  const alreadyAvailableAddonTotal = this.getAlreadyAvailableAddonTotal();

  this.setState(
    {
      upgradeDetails: {
        ...this.state.upgradeDetails,
        addon: tempData,
        addonId: this.state.activeContainer,
        alreadyAvailableAddonTotal, // 👈 save in state
        getAllAddonData: this.state.getAllAddonData // 👈 save in state
      }
    },
    async () => {
      // ✅ save in localStorage
       localStorage.setItem("upgradeDetails", JSON.stringify(this.state.upgradeDetails));

      // existing code
      // if (this.props?.userSubscription?.plans.id !== 1) {
      //   await this.buildPost(
      //     this,
      //     "/payment/notificationUpgraded"
      //   )({
      //     plan_id: this.props?.userSubscription?.plans.id,
      //     addon_id: this.state.activeContainer,
      //     schoolId: this.props.school?.id
      //   });
      // }
       // this.props.history.push(`/${this.props.school?.slug}/purchase-plan`)
              // if (this.state?.upgradeDetails?.onlyBuyAddon === true) {
              //   window.open(ZENDESK_PARENT_SERVEY)
              // } else {
              //   window.open(ZENDESK_UPGRADE_PLAN)
              // }
      this.props.history.push(`/${this.props.school?.slug}/purchase-plan`)
    
    
  })
}

          public render() {
            const {
              appContext: { user, baseUri },
              classes,
            } = this.props;
            console.log(user, classes, baseUri)
            const { activeContainer, subscriptionPlan } = this.state
            const isActivePlan = this.props.userSubscription?.plans?.id === subscriptionPlan?.id;
            const hasSelectedAddon = this.state.activeContainer?.length > 0;
            //  hide only in this ONE case
            const hideButtons = isActivePlan && !hasSelectedAddon;

            return (
              <div>
                {this.state.loader && <div className="loader-bg-color">
                  <LoadingSpinner /></div>}
                <Page
                  header={'Subscription Plans'}
                  subtitle={''}
                >
                  <div>
                    <div className="container">
                      <div className="content">
                        <div className="starter-plan">
                          <h3>You selected the <span>{subscriptionPlan?.title} plan.</span> <br />
                            Would you like to add on some of our favorite plan enhancements?
                          </h3>
                        </div>


                       <div className="row start-flex addonboxwrapper">
                          {
                            this.state.getAllAddonData.length > 0 && this.state.getAllAddonData?.map((item: any) => {
                              const isAlready = item?.is_available === true
                              return (
                                <div className="col-lg-4" key={item?.id}>
                                  <div
                                    className={`customize ${activeContainer?.includes(item?.id) ? 'active' : ''}`}
                                    style={isAlready ? { border: '2px solid #FFD54F', background: 'rgba(255, 235, 59, 0.12)' } : {}}
                                    onClick={isAlready ? undefined : () => this.toggleContainer(item.id)}>

                                    <div className="customize-content">
                                      <h2>{item.title}</h2>
                                      {isAlready && (
                                        <div style={{ color: '#8D6E00', fontWeight: 600, marginTop: 6 }}>
                                          This addon is already available in your plan.
                                        </div>
                                      )}

                                      <p className="custo-parag"><br />{item?.description} </p>

                                    </div>
                                    <div className="custom-div">
                                      <button className="custom-btn" disabled={isAlready} style={isAlready ? { opacity: 0.6, cursor: 'not-allowed' } : {}}>${item?.price}/{item?.payment_frequency_type}</button>
                                    </div>
                                  </div>
                                </div>
                              )
                            })
                          }



                          {/* 
                                                            <div className="col-lg-4">
                                                                  <div
                                                                        className={`customize ${activeContainer === 2 ? 'active' : ''}`}
                                                                        onClick={() => this.toggleContainer(2)}>
                                                                        <div className="customize-content">
                                                                              <h2>Parent Surveys</h2>
                                                                              <p className="custo-parag">Positive parent engagement is the key to long- term success in athletics. Partner with parents to harness the full potential of your athletic community. </p>

                                                                        </div>
                                                                        <div className="custom-div">
                                                                              <button className="custom-btn">$200/year</button>
                                                                        </div>
                                                                  </div>
                                                            </div>
                                                            <div className="col-lg-4">
                                                                  <div
                                                                        className={`customize ${activeContainer === 3 ? 'active' : ''}`}
                                                                        onClick={() => this.toggleContainer(3)}>
                                                                        <div className="customize-content">
                                                                              <h2>Athletic Director Surveys</h2>
                                                                              <p className="custo-parag">Practice what you preach. Before you gather data about your coaches, invite them to provide feedback about your leadership as the Athletic Director.</p>

                                                                        </div>
                                                                        <div className="custom-div">
                                                                              <button className="custom-btn">$150/year</button>
                                                                        </div>
                                                                  </div>
                                                            </div> */}

                        </div>

                        {/* {(() => {
                          const allAlreadyAvailable = this.state.getAllAddonData.length > 0 && this.state.getAllAddonData.every((itm: any) => itm?.title !=="" ? true:false
                          // .is_available === true
                        )
                          return ( */}
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <div className="button-next" style={{ marginRight: 20 }}>
                            <button className="sign-btn" onClick={() => {
                              this.props.history.goBack();
                            }}><span className="next-span-btn">PREV</span></button>
                          </div>
                          {!hideButtons && (
                            <div className="button-next">
                              <button
                                className="sign-btn"
                                onClick={() => {
                                  this.NextHandler();
                                }}
                              >
                                <span className="next-span-btn">NEXT</span>
                              </button>
                            </div>
                          )}
                        </div>                  
                        {!hideButtons && (
                          <div className="next-btn">
                            <button
                              className="no-thanks"
                              onClick={() => {
                                if (this.state?.upgradeDetails?.onlyBuyAddon === true) {
                                  this.props.history.goBack();
                                }
                              }}
                            >
                              <span>NO THANKS</span>
                            </button>
                          </div>
                        )}

                      </div>
                    </div>
                  </div>

                </Page>
              </div>
            );
          }


        }
      )
    )
  )
);



// WEBPACK FOOTER //
// ./src/pages/director/upgradeSubscription/addonPlanUpgrade.tsx